import type { ToolEvent } from "@lumen/shared";
import { formatToolDuration } from "./ToolEventTimestamp.utils";

export function ToolEventTimestamp({
  event,
  className,
}: {
  event: Pick<ToolEvent, "startedAt" | "finishedAt">;
  className: string;
}) {
  if (!event.startedAt) return null;

  const startedAt = new Date(event.startedAt);
  const time = startedAt.toLocaleTimeString();
  const title = startedAt.toLocaleString();
  const duration = event.finishedAt
    ? formatToolDuration(event.startedAt, event.finishedAt)
    : "";

  return (
    <div className={className} title={title}>
      {time}
      {duration ? ` · ${duration}` : ""}
    </div>
  );
}
